import { Category } from "./filters"

export const categoryOptions: { [key: string]: Category } = {
  Dans: "Dans",
  DJ: "DJ",
  Expo: "Expo",
  Fashion: "Fashion",
  Film: "Film",
  Muziek: "Muziek",
  Taal: "Taal",
  Theater: "Theater",
}

export const privacySettingOptions = ["PUBLIC", "CONNECTIONS", "PRIVATE"]

export const contactPrefOptions = ["Telefoon", "Whatsapp", "Instagram", "Email"]

export const regionPersonTypes = ["TEAM", "COACH", "AMBASSADOR", "JONGERENRAAD", "RAAD_VAN_TOEZICHT"]

export const eventPersonTypes = ["SPEAKER", "HOST", "TEACHER"]

export const competitionPersonTypes = ["JURY", "HOST"]

export const competitionPartnerTypes = ["PARTNER", "FINANCIER"]

export const postTypeOptions = [
  { label: "Ik zoek", value: "LOOKING" },
  { label: "Ik bied", value: "OFFERING" },
]

export const statusOptions = [
  { label: "Goedgekeurd", value: "ACCEPTED" },
  { label: "Afvaller", value: "REJECTED" },
  { label: "Wachtlijst", value: "WAITING_LIST" },
  { label: "Afvaller Selectieronde", value: "REJECTED_PRE_ROUND" },
]

export const difficultyRatingOptions: [number, number, number, number, number] = [1, 2, 3, 4, 5]

export const schoolTypeOptions = [
  "VMBO",
  "HAVO",
  "VWO",
  "MBO",
  "HBO/Universiteit",
  "Niet op school",
  "Anders",
]

export const pronounOptions: { [key: string]: string } = {
  "Die/diens": "Die/diens",
  "Hen/hun": "Hen/hun",
  "Hij/hem": "Hij/hem",
  "Zij/haar": "Zij/haar",
  "Zij/hun": "Zij/hun",
  "Weet ik niet": "Weet ik niet",
  "Anders, namelijk": "Anders, namelijk",
}

export const howDidYourHearOptions = [
  "Ik kende Kunstbende al",
  "Via Instagram",
  "Ik ben gespot op Instagram",
  "Via YouTube",
  "Via TikTok",
  "Via Facebook",
  "Via een mail van Kunstbende",
  "Via een poster van Kunstbende",
  "Via vrienden",
  "Via een docent",
  "Via mijn ouders/verzorgers",
  "Via mijn dansschool, muziekschool of andere kunstles",
  "Via een andere wedstrijd",
  "Via een (online) bezoek van Kunstbende in mijn klas / op mijn school",
  "Via een bezoek van Kunstbende aan mijn buurthuis",
  "Via een ambassadeur / promotor die mij (online) gespot heeft",
  "Ik kwam Kunstbende tegen op een (online) festival",
]

export const howDidYourHearMultiOptions: { [key: string]: string } = {
  "Ik kende Kunstbende al": "Ik kende Kunstbende al",
  "Via Instagram": "Via Instagram",
  "Ik ben gespot op Instagram": "Ik ben gespot op Instagram",
  "Via YouTube": "Via YouTube",
  "Via TikTok": "Via TikTok",
  "Via Facebook": "Via Facebook",
  "Via een mail van Kunstbende": "Via een mail van Kunstbende",
  "Via een poster van Kunstbende": "Via een poster van Kunstbende",
  "Via vrienden": "Via vrienden",
  "Via een docent": "Via een docent",
  "Via mijn ouders/verzorgers": "Via mijn ouders/verzorgers",
  "Via mijn dansschool, muziekschool of andere kunstles":
    "Via mijn dansschool, muziekschool of andere kunstles",
  "Via een andere wedstrijd": "Via een andere wedstrijd",
  "Via een (online) bezoek van Kunstbende in mijn klas / op mijn school":
    "Via een (online) bezoek van Kunstbende in mijn klas / op mijn school",
  "Via een bezoek van Kunstbende aan mijn buurthuis": "Via een bezoek van Kunstbende aan mijn buurthuis",
  "Via een ambassadeur / promotor die mij (online) gespot heeft":
    "Via een ambassadeur / promotor die mij (online) gespot heeft",
  "Ik kwam Kunstbende tegen op een (online) festival": "Ik kwam Kunstbende tegen op een (online) festival",
}

export type Provision =
  | "Geschikt voor Doven/Slechthorenden"
  | "Gebarentolk"
  | "Geschikt voor Blinden/Slechtzienden"
  | "Audio Descriptie"
  | "Rolstoeltoegankelijk"
  | "Ontprikkelruimte"
  | "Voorstellingen met Schrijftolk"
  | "Geschikt voor Blinden/Slechtzienden"
  | "Goed te Bereiken met OV"
  | "Goed te Bereiken met De Auto"
  | "Ook Online bij Te Wonen"
  | "Triggerwarning"

export const disabilityProvisionsMultiOptions: { [key: string]: Provision } = {
  "Suitable for deaf": "Geschikt voor Doven/Slechthorenden",
  "Sign language interpreter": "Gebarentolk",
  "Suitable for blind": "Geschikt voor Blinden/Slechtzienden",
  "Audio description": "Audio Descriptie",
  "Wheelchair accessible": "Rolstoeltoegankelijk",
  "Low-stimulus event": "Ontprikkelruimte",
  "Workshop with writing enterpreter": "Voorstellingen met Schrijftolk",
  "Easily accessible by public transport": "Goed te Bereiken met OV",
  "Easily accessible by car": "Goed te Bereiken met De Auto",
  "Also available online": "Ook Online bij Te Wonen",
  Triggerwarning: "Triggerwarning",
}

export const howDidYouHearEventOptions = [
  "Kunstbende.nl",
  "Instagram",
  "Flyer / poster",
  "Een vriend(in)",
  "Een docent",
  "Anders, namelijk",
]
